import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { HijriYearPage } from "@/components/pages/HijriYearPage";
import { HIJRI_MONTHS, parseHijriMonthSlug } from "@/lib/calendar/hijri";

export const Route = createFileRoute("/kalender-hijriah/$hyear/")({
  beforeLoad: ({ params }) => {
    // Legacy sitemap leaked literal route templates like
    // /kalender-hijriah/$hyear/. `throw new Response()` from a loader is
    // unsupported by TanStack Router and crashes SSR with 500. Use
    // `notFound()` for a clean 404 — Google still removes them.
    if (params.hyear.startsWith("$")) {
      throw notFound();
    }
  },
  loader: ({ params }) => {
    // Allow pretty slug `/kalender-hijriah/ramadhan-1447` here too — redirect to canonical.
    if (!/^\d+$/.test(params.hyear)) {
      const parsed = parseHijriMonthSlug(params.hyear);
      if (!parsed) throw notFound();
      throw redirect({
        to: "/kalender-hijriah/$hyear/$hmonth/",
        params: { hyear: String(parsed.hYear), hmonth: String(parsed.hMonth) },
      } as any);
    }
    const hYear = parseInt(params.hyear, 10);
    if (!Number.isFinite(hYear) || hYear < 1300 || hYear > 1600) throw notFound();
    return { hYear };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const y = loaderData.hYear;
    const title = `Kalender Hijriah ${y} H - Tanggal Hijriah & Masehi Lengkap`;
    const desc = `Kalender Islam (Hijriah) tahun ${y} H lengkap dengan tanggal Masehi, hari libur nasional Indonesia, ${HIJRI_MONTHS.join(", ")}.`;
    const idUrl = `https://hari.co.id/kalender-hijriah/${y}/`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: idUrl },
        { property: "og:locale", content: "id_ID" },
        { property: "og:locale:alternate", content: "en_US" },
      ],
      links: [{ rel: "canonical", href: idUrl }],
    };
  },
  component: () => {
    const { hYear } = Route.useLoaderData();
    return <HijriYearPage hYear={hYear} />;
  },
  notFoundComponent: () => <div className="p-8 text-center">Tahun Hijriah tidak valid.</div>,
  errorComponent: ({ error }) => <div className="p-8 text-center">Error: {error.message}</div>,
});